import { LinkButton, theme, useToast } from '@arnold/common';
import styled from '@emotion/styled/macro';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Origin, useResetPasswordMutation } from '../../generated/hooks';

const TextWrap = styled.div`
  margin-bottom: ${theme.spacing.h};
  text-align: center;
`;

interface IProps {
  email: string;
}

const RecoverPasswordSuccess = ({ email }: IProps) => {
  const [t] = useTranslation('recoverPassword');
  const { addToast } = useToast();
  const [counter, setCounter] = useState(10);
  const [resetPassword] = useResetPasswordMutation();

  const startCountdown = (seconds: number) => {
    let index = seconds;

    const interval = setInterval(() => {
      index--;
      setCounter(index - 1);
      if (index === 0) {
        clearInterval(interval);
        setCounter(0);
      }
    }, 1000);
  };
  useEffect(() => {
    startCountdown(11);
  }, []);

  return (
    <>
      <TextWrap>
        <Trans i18nKey="recoverPassword:resetPasswordText" values={{ email, time: counter }}>
          Na e-mail <strong>{email}</strong> jsem ti poslal odkaz k vytvoření nového hesla.
        </Trans>
      </TextWrap>
      <div className="text-center">
        <LinkButton
          disabled={counter > 0}
          data-cy={'admin-reset-password-button'}
          onClick={async () => {
            try {
              await resetPassword({ variables: { username: email, origin: Origin.SelfCare } });
            } catch (e) {
              console.error(e);
            }
            startCountdown(10);
            addToast(t('loginForm:modalTitle'));
          }}
        >
          {t('sendAgain')}
        </LinkButton>
      </div>
    </>
  );
};

export default RecoverPasswordSuccess;
